<template>
  <el-dialog
    title="区域分配"
    :visible.sync="regionDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center>
    <div>
      <div class="flex align-center margin-bottom-sm">
        <span>小区选择：</span>
        <el-select v-model="communityId" placeholder="请选择小区" class="flex-sub" multiple @change="hanldChange">
          <el-option
            v-for="item in communityList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="flex align-start margin-bottom-sm" v-if="communityId.length>0">
        <span>区域选择：</span>
        <div class="flex-sub">


          <div v-for="(xiaoqu,xq) in communityList" :key="xiaoqu.id">
            <div v-if="xiaoqu.chiose">
              <h3 class="margin-bottom-xs">{{ xiaoqu.name }}</h3>
              <div v-for="(item,index) in xiaoqu.louData" :key="item.id" class="margin-bottom">
                <div v-if="item.element_list.length>0">
                  <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.check" :label="item.id"
                               @change="handleCheckAllChange(xq,index)">
                    {{ item.building_name }}
                  </el-checkbox>
                  <div class="margin-top-xs flex align-center flex-wrap">
                    <el-checkbox v-for="unit in item.element_list" v-model="unit.check" :label="unit.id" :key="unit.id"
                                 @change="handleCheckChange(xq,index)">{{ unit.element_name }}
                    </el-checkbox>
                  </div>
                </div>


              </div>
            </div>
          </div>


        </div>
      </div>

      <div class="flex align-center justify-around ">
        <el-button class="msg-btn" @click="reset">取消</el-button>
        <el-button class="msg-btn" type="primary" @click="submitData">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {getLouMenListByXiaoQuId, xiaoQuListByXiangMuId} from "@/api/community";
import {getYuanGongGuanLiXiaoQu, yuanGongGuanLiXiaoQu} from "@/api/login";

export default {
  name: "regionDialog",
  data() {
    return {
      id: '',
      communityId: '',
      communityList: [],
      unitList: [],
    }
  },
  props: {
    regionDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  created() {
  },
  components: {},
  methods: {
    //  提及分配
    async submitData() {
      if (!this.communityId) return this.$message.error('请选择要分配的小区')
      let _floor = [];
      let _unit = [];
      this.communityList.map(item => {
        if(item.chiose){
          item.louData.map(obj => {
            if (obj.isIndeterminate || obj.check) _floor.push(obj.id)
            obj.element_list.map(items => {
              if (items.check) _unit.push(items.id)
            })
          })
        }
      })
      if (_unit.length === 0) return this.$message.error('请选择要分配的区域')
      let _state = await yuanGongGuanLiXiaoQu(this.setId, this.communityId.join(','), this.setItem.id, _floor.join(','), _unit.join(','), this.id)
      this.$message.success(_state.info)
      this.$emit('cancelDialog', false)
    },
    //  取消
    reset() {
      this.$emit('cancelDialog', false)
    },

    //  楼栋全部选择/取消选择
    handleCheckAllChange(xq, index) {
      let _state = this.communityList[xq].louData[index].check
      if (_state) this.communityList[xq].louData[index].isIndeterminate = false
      this.communityList[xq].louData[index].element_list.map(item => {
        item.check = _state
      })
    },
    //  单元选择操作
    handleCheckChange(xq, index) {
      let _num = 0
      this.communityList[xq].louData[index].element_list.map(item => {
        if (item.check) _num++
      })
      if (_num > 0) {
        this.communityList[xq].louData[index].isIndeterminate = true
      } else {
        this.communityList[xq].louData[index].isIndeterminate = false
      }
      if (_num === this.communityList[xq].louData[index].element_list.length) {
        this.communityList[xq].louData[index].check = true
        this.communityList[xq].louData[index].isIndeterminate = false
      } else {
        this.communityList[xq].louData[index].check = false
      }
    },
    //  获取小区下的单元
    async getUnitList() {
      let _data = await getLouMenListByXiaoQuId(this.communityId.join(','))
      _data.data.map(item => {
        item.isIndeterminate = false
        item.check = false
        item.element_list.map(items => {
          items.check = false
        })
      })
      this.unitList = _data.data
    },
    hanldChange() {
      this.communityList.map(item => {
        if (this.communityId.indexOf(item.id) !== -1) {
          item.chiose = true
        } else {
          item.chiose = false
        }
      })
    },
    //  获取可分配的小区
    async getCommunityList() {
      let _data = await xiaoQuListByXiangMuId(this.setId)
      _data.data.map(item => {
        item.chiose = false
      })
      this.communityList = _data.data
      this.getBindInfo()
    },
    //  获取员工绑定的信息
    async getBindInfo() {
      let _data = await getYuanGongGuanLiXiaoQu(this.setItem.id)
      if (_data.status === 800) return
      this.communityId = _data.data.xiaoqu_id.split(',').map(Number)
      await this.hanldChange()
      this.id = _data.data.id
      let _unit = _data.data.danyuanhao_str_id.split(',').map(Number)
      // await this.getUnitList()
      await this.linkedData(_unit)
    },
    //  修改获取单元的选择状态
    linkedData(unit) {
      let _info = JSON.parse(JSON.stringify(this.communityList))
      _info.map(item => {
        item.louData.map(obj => {
          obj.element_list.map(items => {
            if (unit.indexOf(items.id) !== -1) {
              items.check = true
            }else {
              items.check = false
            }
          })
        })
      })
      _info.map(item => {
        item.louData.map(obj => {
          let _num = 0
          obj.element_list.map(items => {
            if (items.check) _num++
          })
          if (_num > 0 && _num !== obj.element_list.length) {
            obj.isIndeterminate = true
          }
          if (_num > 0 && _num === obj.element_list.length) {
            obj.check = true
          }
        })
      })
      console.log(_info)
      this.communityList = _info
    }
  },
  filters: {},
  watch: {
    regionDialog() {
      if (this.regionDialog) {

        this.getCommunityList()
      } else {
        this.id = ''
        this.communityId = []
        this.communityList = []
        this.unitList = []
      }
    }
  },
}
</script>

<style scoped lang="scss">

</style>
